import React, { createContext, useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCurrent } from "../redux/settings/selectors";


export const FaviconProvider = ({ children }: { children: React.ReactNode }) => {
    const [favicon, setFavicon] = useState<string | null>(null);
    const result = useSelector(selectCurrent)
    const { favIcon, tenantName } = result

    useEffect(() => {
        setFavicon(favIcon)
        const updateTitle = () => {
            document.title = tenantName;
        };
        updateTitle();
        // Listen for changes to localStorage
        window.addEventListener("storage", updateTitle);
        // Cleanup listener on unmount
        return () => {
            window.removeEventListener("storage", updateTitle);
        };
    }, [result]);

    useEffect(() => {
        if (favicon) {
            const fav = document.getElementById("favicon") as HTMLLinkElement;
            if (fav) fav.href = favicon;
        }
    }, [favicon]);

    return (
        <>
            {children}
        </>

    );
};
